var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93183 8.63091C3.07325 8.25862 3.43005 8.01248 3.8283 8.01248H8.4433L8.4433 5.37421C8.44435 5.20713 8.49026 5.0434 8.57624 4.90013C8.66221 4.75687 8.78509 4.63932 8.93203 4.55979C9.07897 4.48025 9.24457 4.44164 9.41154 4.448C9.5785 4.45436 9.74069 4.50544 9.88115 4.59592C13.0679 5.97533 14.7328 6.98374 17.4992 9.19311C17.7613 9.40244 17.9491 9.67019 17.9491 9.99118C17.9491 10.3122 17.7236 10.5797 17.4992 10.7893C14.838 13.2747 13.1647 14.2745 9.88115 15.3864C9.73929 15.4713 9.57742 15.5169 9.41214 15.5186C9.24685 15.5203 9.08407 15.4781 8.94047 15.3962C8.79687 15.3144 8.6776 15.1958 8.59488 15.0527C8.51216 14.9096 8.46895 14.7471 8.46968 14.5818L8.46968 11.9435H3.74166C3.40727 11.9435 3.1034 11.7491 2.96327 11.4455C2.57713 10.6089 2.54392 9.65203 2.87115 8.79065L2.93183 8.63091Z",
    fill: "#C77CBD",
    fillOpacity: 0.09,
    stroke: "white",
    strokeWidth: 1.45489,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIconWhite);
export default __webpack_public_path__ + "static/media/forward-icon-white.0d98bccde8160ddb8417dd2bcef71716.svg";
export { ForwardRef as ReactComponent };